import { render, staticRenderFns } from "./SalesmanDetail.vue?vue&type=template&id=93708b30&"
import script from "./SalesmanDetail.vue?vue&type=script&lang=js&"
export * from "./SalesmanDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports